import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'

export const PrivateRoute = ({ children, isUserLoggedIn }) => {
  const location = useLocation()
  if (!isUserLoggedIn) {
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />
  }
  return children
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
}
